import { extend } from "vee-validate";
/**
 * Additional rules to use with vee-validate in form validation
 */
export var CustomRule;
(function (CustomRule) {
    /** minimum delay from today to select date
     * provide today parameters when using `addValidationRules`
     * example usage => :rules="`required|${CustomRule.InitialDayDelay}:${10}|...`" */
    CustomRule["InitialDateDelay"] = "initialDateDelay";
    /** starting date happens before end date (start day = end day)
     *
     * <b>IMPORTANT</b>: end date field MUST be required
     *
     * <i>Example usage</i>: in date picker =>
     * `rules="startBeforeEnd:@end"` */
    CustomRule["StartBeforeEnd"] = "startBeforeEnd";
    /** disable saturday and sunday selection
     *
     * <i>Example usage</i>: in date picker =>
     * `rules="disallowWeekend"` */
    CustomRule["DisallowWeekend"] = "disallowWeekend";
    /** Any of those values is truthy
     *
     * <i>Example usage</i>: => `:rules="{any:[category1,category2,...,category5]}"` */
    CustomRule["Any"] = "any";
    /** Checkbox is checked
     *
     * <i>Example usage</i>: => `:rules="{checked}"` */
    CustomRule["Checked"] = "checked";
})(CustomRule || (CustomRule = {}));
/**
 * When referencing value generated in v-for, it might be a dict instead of an array
 * @param target value from validation rule (example: start:@>>>end<<<)
 */
function getTargetValue(target) {
    if (target.constructor === Array) {
        return target[0];
    }
    else if (target.constructor === Object) {
        // @ts-ignore
        return target.target;
    }
    else {
        return null;
    }
}
export function addValidationRules(rules, today) {
    rules.forEach(function (rule) {
        switch (rule) {
            case CustomRule.InitialDateDelay: {
                // alternative to validate date https://github.com/logaretm/vee-validate/issues/2191
                extend(rule, {
                    params: ['target'],
                    validate: function (value, target) {
                        var delayValue = getTargetValue(target);
                        if (value && target && today) {
                            var initialDelay = parseInt(delayValue);
                            var secondsUntilMinDate = new Date().setDate(today + initialDelay - 1);
                            var min = new Date(secondsUntilMinDate);
                            var date = new Date(value);
                            return min <= date;
                        }
                        return false;
                    }
                });
                break;
            }
            case CustomRule.StartBeforeEnd: {
                extend(rule, {
                    params: ['target'],
                    validate: function (value, target) {
                        var endValue = getTargetValue(target);
                        if (endValue === null) {
                            // undefined end date, no comparison to do, no highlight needed yet
                            // NOTE: end date has to be required
                            return true;
                        }
                        else if (value) {
                            var start = new Date(value);
                            var end = new Date(endValue);
                            return start <= end;
                        }
                        return false;
                    }
                });
                break;
            }
            case CustomRule.DisallowWeekend: {
                extend(rule, {
                    validate: function (value) {
                        if (value) {
                            var day = new Date(value);
                            // Do not allow saturday or sunday
                            return day.getDay() != 0 && day.getDay() != 6;
                        }
                        return false;
                    }
                });
                break;
            }
            case CustomRule.Any: {
                extend(rule, {
                    validate: function (value, values) {
                        return values.some(Boolean);
                    }
                });
                break;
            }
            case CustomRule.Checked: {
                extend(rule, {
                    validate: function (value) {
                        return !!value;
                    }
                });
                break;
            }
            default: {
                break;
            }
        }
    });
}
